var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoldertree = function SvgFoldertree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FACC15",
    d: "M12 12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2zM0 4.764V2a2 2 0 0 1 2-2h3.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A.5.5 0 0 0 8.414 2H12a2 2 0 0 1 2 2v.764A3 3 0 0 0 12 4H2c-.768 0-1.47.289-2 .764"
  })));
};
export default SvgFoldertree;